import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class EmailService {

  constructor(private http: HttpClient) { }

  createEmailConfig(data:any): Observable<any> {
    return this.http.post(environment.createEmailConfig,data);
  }
  getEmailConfig(data:any): Observable<any> {
    return this.http.post(environment.getEmailConfig,data);
  }

  updateEmailConfig(data:any): Observable<any> {
    return this.http.post(environment.updateEmailConfig,data);
  }



  
  
  
  
  
}
